import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { useModalStore } from 'src/hooks/useStore';
import Modal from 'src/components/ui-kit/Modal';
import { mobilePoint } from 'src/styles/globalStyle';

const Wrapper = styled.div`
  width: 100%;
  padding: 32px 40px;
  text-align: center;
`;
const Content = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 40px;
  color: ${colors.BlueGray_800};
  gap: 5px;

  @media (max-width: ${mobilePoint}) {
    display: grid;
    text-align: left;
  }
`;
const Button = styled.button`
  width: max-content;
  height: 40px;
  border-radius: 4px;
  background-color: ${colors.primaryGreen_400};
  color: ${colors.white};
  font-size: 18px;
  margin-top: 2em;
  padding: 0 1em;
  cursor: pointer;
`;

interface IProps {
  width?: string;
  children: React.ReactNode;
}

/**
 * 提醒視窗
 */
const AlertModal: React.FC<IProps> = ({ width, children }) => {
  const closeModal = useModalStore((state) => state.closeModal);

  return (
    <Modal isAlert={true} width={width ? width : '20em'}>
      <Wrapper>
        <Content>{children}</Content>
        <Button onClick={() => closeModal()}>關閉</Button>
      </Wrapper>
    </Modal>
  );
};

export default AlertModal;
